import { useSuspenseQuery } from "@tanstack/react-query";

import { getConfig } from "lib/get-config";

import { getToc } from "./get-toc";

export function useToc() {
  const { art } = getConfig();
  const { data: toc } = useSuspenseQuery({
    queryKey: ["toc", art],
    queryFn: () => getToc(),
  });

  return { toc };
}
